import * as React from 'react';

import { notification } from './../../utils/notification';

export default class Error extends React.Component<any, any> {
    public componentDidMount() {
        this.trigger();
    }

    public componentDidUpdate(prevProps: any) {
        if (this.props.children !== prevProps.children) {
            this.trigger();
        }
    }

    private trigger = () => {
        const error = this.props.children ? this.props.children : 'An error occured.';
        notification.error(error as string, 4000);
    };

    public render() {
        return null;
    }
}
